<div class="wiki-view-article">
  @if (isLoading()) {
    <div class="oph-loading-container">
      <oph-loading></oph-loading>
    </div>
  } @else {
    @if (wikiItem$ | async; as wikiItem) {
      <div class="wiki-view-article-container">
        @if (!isPostFullView()) {
          <div class="wiki-view-article__header">
            <button class="wiki-view-article__close-button" type="button" (click)="onCancel()">
              <div class="wiki-view-article__close-button-container">
                <oph-icon name="chevron-down-brown" [size]="14"></oph-icon> <span>Close</span>
              </div>
            </button>
          </div>
        }

        <h1 class="wiki-view-article__title">
          {{ wikiItem.title }}
        </h1>

        <div
          class="wiki-view-article__editor-container"
          [ngClass]="{'wiki-view-article__editor-container--full-view': isPostFullView()}"
        >
          <oph-quill-editor
            [bounds]="'.wiki-view-article-container'"
            [placeholder]=""
            [quillConfig]="{toolbar: false}"
            [content]="wikiItem.content"
            [isReadOnly]="true"
            [quillStyles]="quillStyles"
          />
        </div>
      </div>
    }
  }
</div>
